import { AwningIcon } from './AwningIcon';

/**
 * author: Jeff Anders
 * id 8A405D94-6047-4B9B-BB52-24BD1416441F
 * name awning
 * version: 7.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/awning.svg
 * tags
 * - Home Automation 
 */
export const MarquiseIcon = AwningIcon;
export default MarquiseIcon